import { Injectable } from "@angular/core";
import { CSSColorService } from "../css-color/css-color.service";

@Injectable()
export class EnvColorService {
  // These environments have a predefined class name suffix so they can be given
  // specific styles, e.g. red for production, green for development, etc.
  private COMMON_ENVS: any = {
    production: ["prod"],
    staging: ["stag"],
    development: ["dev", "develop"],
  };

  private ENV_COLORS: any = {
    production: this.cssColorService.getColor("--ab-red-400"),
    staging: this.cssColorService.getColor("--ab-orange-500"),
    development: this.cssColorService.getColor("--ab-green-500"),
    "color-0": this.cssColorService.getColor("--ab-blue-100"),
    "color-1": this.cssColorService.getColor("--ab-blue-200"),
    "color-2": this.cssColorService.getColor("--ab-blue-400"),
    "color-3": this.cssColorService.getColor("--ab-blue-300"),
    "color-4": this.cssColorService.getColor("--ab-blue-600"),
    "color-5": this.cssColorService.getColor("--ab-blue-700"),
    "color-6": this.cssColorService.getColor("--ab-green-600"),
    "color-7": this.cssColorService.getColor("--ab-green-200"),
    "color-8": this.cssColorService.getColor("--ab-green-400"),
    "color-9": this.cssColorService.getColor("--ab-green-700"),
    "color-10": this.cssColorService.getColor("--ab-orange-400"),
    "color-11": this.cssColorService.getColor("--ab-orange-600"),
    "color-12": this.cssColorService.getColor("--ab-orange-300"),
    "color-13": this.cssColorService.getColor("--ab-orange-200"),
    "color-14": this.cssColorService.getColor("--ab-red-700"),
    "color-15": this.cssColorService.getColor("--ab-grey-600"),
  };

  constructor(private cssColorService: CSSColorService) {}

  public colorClass(environment: any) {
    if (environment == null) {
      return;
    }
    return this.envColorClass(environment);
  }

  public colorString(env: any) {
    const suffix = this.getEnvSuffix(env);
    if (suffix != null) {
      return this.ENV_COLORS[suffix];
    }

    const COLOR_CHOICES = 16;
    const hsh = this.hashCode(env) % COLOR_CHOICES;
    return this.ENV_COLORS[`color-${hsh}`];
  }

  // Returns a consistent class name for a given environment string.
  private envColorClass(env: any) {
    const suffix = this.getEnvSuffix(env);
    if (suffix != null) {
      return `ab-env-${suffix}`;
    }

    // Other envs are hashed to a number.
    const COLOR_CHOICES = 16;
    const hsh = this.hashCode(env) % COLOR_CHOICES;
    return `ab-env-${hsh}`;
  }

  private getEnvSuffix(env: any) {
    for (const suffix of Object.keys(this.COMMON_ENVS)) {
      const aliases = this.COMMON_ENVS[suffix];
      if (suffix === env) {
        return suffix;
      }
      for (const alias of aliases) {
        if (alias === env) {
          return suffix;
        }
      }
    }
  }

  // Copied from http://stackoverflow.com/a/15710692/268774.
  private hashCode(s: any) {
    const reducer = (hash: any, str: string) => {
      /* tslint:disable:no-bitwise */
      hash = (hash << 5) - hash + str.charCodeAt(0);
      return hash & hash;
      /* tslint:enable:no-bitwise */
    };

    return Math.abs(s.toString().split("").reduce(reducer, 0));
  }
}
